module.exports = __webpack_public_path__ + "static/img/banners.5d61cf1f.png";